import * as Sentry from '@sentry/react';
import { env } from './env';

if (env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: env.VITE_SENTRY_DSN,
    environment: env.VITE_SENTRY_ENVIRONMENT,
    release: env.VITE_SENTRY_RELEASE,
    tracesSampleRate: 0.1,
  });
}
